/**
 * StatKeys — all stat keys used by the game's modifier system.
 *
 * These are the strings used as keys in ModifierBag.add() / .get().
 * Centralised here so consumers and sources both reference the same keys.
 */

// --- Offense ---
/**
 * Damage stat — supports all three modifier tiers on one key:
 *   flat:    base ATK, skill bonuses, item bonuses
 *   percent: +20% from a perk
 *   mult:    x2 from a buff
 */
export const DAMAGE = "damage";

// --- Defense ---
/** Flat armor gained at the start of each turn. */
export const ARMOR_FLAT = "armor.flat";
/** Flat bonus to max HP. */
export const MAX_HP_FLAT = "maxHp.flat";

// --- Resources ---
/** Flat bonus to max AP per turn. */
export const AP_MAX_FLAT = "ap.max.flat";

// --- Grid ---
/** Flat override for grid size (3, 4, or 5). Highest value wins. */
export const GRID_SIZE = "grid.size";

// --- Economy ---
/** Additive % bonus to gold rewards (e.g. 0.1 = +10%). */
export const GOLD_PERCENT = "gold.percent";
/** Additive % bonus to XP earned (e.g. 0.2 = +20%). */
export const XP_PERCENT = "xp.percent";

// --- Healing ---
/** Flat bonus to all healing received. */
export const HEAL_FLAT = "heal.flat";
